import clsx from 'clsx';
import styles from '../../components/organisms/widget/widget.module.scss';
import { WidgetConfig, WidgetType } from 'modules/dashboard/types';

export const getWidgetClassName = (
  widgetConfig: WidgetConfig,
  className?: string,
  hasMounted?: boolean
) => {
  return clsx(
    styles.widget,
    widgetConfig.type === WidgetType.hotlinks ? styles.widgetNoBorder : styles.widgetBorder,
    className,
    {
      ...(styles.fadeInUp && hasMounted ? { [styles.fadeInUp]: true } : {})
    }
  );
};
